// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-composition-icon-category-__icon-category-module___container","title":"src-components-composition-icon-category-__icon-category-module___title","iconGrid":"src-components-composition-icon-category-__icon-category-module___iconGrid"};


//////////////////
// WEBPACK FOOTER
// ./src/components/composition/icon-category/icon-category.module.css
// module id = 141
// module chunks = 0